import * as React from 'react';
import { Typography } from '@mui/material';

export default function HomeScreen() {
  return (
    <div style={{ height: 400, width: '100%' }}>
      <>
        <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>
          Welcome to Harnon Marketo Coupons.
        </Typography>
      </>
    </div>
  );
}
